import React from 'react'

import { useTranslation } from 'react-i18next'
import TitleComponent from '../../../global/Custom/TitleComponent/TitleComponent'
import ProductCreateScreen from './ProductCreateScreen'

function ProductCreate() {
  const {t} = useTranslation()

  return (
    <div>
        <TitleComponent title={t('Tạo mới sản phẩm')} isExist={false} />
        <ProductCreateScreen/>
    </div>
  )
}

export default ProductCreate
